import $ from 'jquery'
import 'jquery.marquee'

$('.hamburger').on('click', function () {
  $('body').toggleClass('menu-active')
  $(this).find('i').toggleClass('smat-icon-hamburger smat-icon-close')
})

$('.site-header__menu .menu-item-has-children > a').on('click', function (e) {
  if (window.matchMedia('(max-width: 991.98px)').matches) {
    e.preventDefault()

    $(this).parent().toggleClass('active')
    $(this).parent().find('ul').slideToggle(250)
  }
})

const header = document.getElementById('masthead')
if (header) {
  const setHeaderPos = () => {
    if (window.scrollY > 0) {
      header.classList.add('main-header--fixed')
    } else {
      header.classList.remove('main-header--fixed')
    }
  }

  document.addEventListener('scroll', setHeaderPos)
  document.addEventListener('load', setHeaderPos)
}

$('.top-bar__contents').marquee({
  duration: 15000,
  gap: 15,
  delayBeforeStart: 0,
  direction: 'left',
  duplicated: true,
})
